import React from "react";
import { Activity, Clock } from "lucide-react";
import { formatDiagnosticDate } from "../../../utils/dateFormatter";

// Helper function to determine status styling
function getStatusStyle(status) {
  if (status === "ON") {
    return "bg-green-500 hover:bg-green-600 border-green-500";
  } else if (status === "OFF") {
    return "bg-red-500 hover:bg-red-600 border-red-500";
  }
  // Default style for unknown status
  return "bg-gray-500 hover:bg-gray-600 border-gray-500";
}

function ProxyStatus({ diagnosticData }) {
  // Extract proxy status data safely
  const proxyData = diagnosticData?.proxyStatus?.[0] || {};
  
  
  // Extract values with defaults - Check for "ON" status as stored in database
  const sProxyStatus = proxyData.s_proxy_status === "ON" ? "ON" : "OFF";
  const cProxyStatus = proxyData.c_proxy_status === "ON" ? "ON" : "OFF";
  const systemTimestamp = formatDiagnosticDate(proxyData.system_timestamp);
  
  return (
    <div className="space-y-4">
      {/* S Proxy Status Card */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Activity className="text-blue-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">S Proxy Status</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-white text-sm font-medium">
          <div className={`${getStatusStyle(sProxyStatus)} px-3 py-2 rounded-lg`}>
            {sProxyStatus}
          </div>
        </div>
      </div>

      {/* C Proxy Status Card */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Activity className="text-blue-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">C Proxy Status</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-white text-sm font-medium">
          <div className={`${getStatusStyle(cProxyStatus)} px-3 py-2 rounded-lg`}>
            {cProxyStatus}
          </div>
        </div>
      </div>

      {/* System Timestamp Card */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Clock className="text-blue-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">System Timestamp</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {systemTimestamp}
        </div>
      </div>
    </div>
  );
}


export default ProxyStatus;